// Normalizes phone numbers to E.164 international format (+1XXXXXXXXXX) for analytics/GTM tracking
export function normalizePhoneNumber(raw: string): string {
  const digits = raw.replace(/^tel:/, "").replace(/\D/g, "");
  if (digits.length === 11 && digits.startsWith("1")) {
    return `+${digits}`;
  }
  if (digits.length === 10) {
    return `+1${digits}`;
  }
  return digits;
}

/**
 * Builds the tel: href for a phone number in E.164 (+1XXXXXXXXXX). tel:
 * hrefs must always be built with this normalizer, never with the display
 * formatter: href="tel:(932) 725-9005" dials a malformed number wherever
 * Invoca's swap has not run yet (and on any swap failure), while
 * tel:+19327259005 always dials. Returns null when no digits are present so
 * call sites can keep their conditional-render guards.
 */
export function telHref(phoneNumberString?: string | null): string | null {
  if (!phoneNumberString) {
    return null;
  }
  const normalized = normalizePhoneNumber(String(phoneNumberString));
  if (!normalized) {
    return null;
  }
  return `tel:${normalized}`;
}

export function formatPhoneNumber(phoneNumberString?: string | null) {
  if (!phoneNumberString) {
    return null;
  }
  const cleanedPhoneNumber = ("" + phoneNumberString).replace(/\D/g, "");

  const matchPhoneNumberFormat = /^(\d{3})(\d{3})(\d{4})$/.exec(
    cleanedPhoneNumber,
  );

  if (matchPhoneNumberFormat) {
    return (
      "(" +
      matchPhoneNumberFormat[1] +
      ") " +
      matchPhoneNumberFormat[2] +
      "-" +
      matchPhoneNumberFormat[3]
    );
  }
  return null;
}
